import React from "react";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Form, Row, Col, Button, Modal, Alert } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight, faCheckCircle } from "@fortawesome/pro-solid-svg-icons";

import { AuthContext } from "../../contexts/AuthContext";
import { PageView, PageViewSection } from "../../components/PageView";
import Price from "../../components/Price";
import Loading from "../../components/Loading";
import {
    InputText,
    InputEmail,
} from "../../components/ModelFormView";
import {
    InputCheckbox
} from "../../components/AppxForm";
import {
    parseBoolOr,
    parseJsonOr,
    isObjectNotEmpty,
    createFormattedAddress,
    moneyFormat
} from "../../components/App/AppxUtils";
import Decoders from "./Decoders";
import DecoderPlans from "./DecoderPlans";
import PlanIcon from "./PlanIcon";

import { GUTTER, COL_SIZE, COL_SIZE_PRICE } from "../../theme";
import "./index.css";

function sumParts(parts) {
    let total = 0;

    for (let key in parts) {
        if (!["stb_mode", "stb_count"].includes(key)) {
            total += parts[key];
        }
    }

    return total;
}

function r2Dec(num) {
    num = parseFloat(num) || 0;

    return Math.round(num * 100) / 100;
}


class SignUpRequest extends React.Component {
    static contextType = AuthContext;

    formRef = React.createRef();
    themeConfig = null;
    plan = {}
    planApiCode = "";
    tvPlan = {};
    tvPlanId = 0;
    defPrices = {};
    decoders = [];
    minRecorders = 0;
    defAddressState = "Quebec";
    defAddressCountry = "Canada";
    paymentMethods = [];

    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        this.planApiCode = params.get('planApiCode') || "";
        this.tvPlanId = params.get('tvPlanId') || 0;
        this.state = {
            loading: true,
            processing: false,
            validUrl: (this.planApiCode !== ""),
            invoice: {
                stb_mode: null,
                stb_count: 0,
                plan: 0,
                tvplan: 0,
                install: 0,
                unlimited_can_usa_long_distance: 0,
                digital_recorder: 0,
                digital_recorder_plus: 0,
                decoders: 0,
            },
            overview: 0,
            decoder: null,
            unlimited_can_usa_long_distance: 0,
            digital_recorder: 0,
            digital_recorder_plus: 0,
            numOfDecoders: 0,
        };

        this.onFinish = this.onFinish.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    async componentDidMount() {
        this.org = this.context.org;
        this.config = this.context.config;
        this.themeConfig = this.context.themeConfig;
        this.showReferral = parseBoolOr(this.config?.showReferral, false);
        this.hasSectionTwoCustom = parseBoolOr(this.config?.hasSectionTwoCustom, false);
        this.hideSectionTwo = parseBoolOr(this.config?.hideSectionTwo, false);

        let { validUrl, invoice, decoder } = this.state;

        if (validUrl) {
            let mdl = await this.context.doModelAction({
                model: 'plan',
                action: 'apicode',
                data: {
                    apiCode: this.planApiCode
                }
            });

            if (mdl != null &&
                isObjectNotEmpty(mdl.data) &&
                mdl.data?.id > 0) {
                this.plan = mdl.data;
                invoice['plan'] = r2Dec(mdl.data.monthlyPrice);

                if (!this.hideSectionTwo && !this.plan.freeSetupFee && !this.hasSectionTwoCustom) {
                    invoice['install'] = r2Dec(mdl.data.planSetupFee);
                }
            }
            else {
                validUrl = false;
            }

            if (this.plan.isTv) {
                this.minRecorders = (this.plan.includeDecoder > 0) ? 0 : 1;
                this.setState({numOfDecoders: this.minRecorders})
            }

            if (validUrl) {
                this.paymentMethods = Array.isArray(this.config?.payment_methods) ? this.config.payment_methods : [];
                this.defPrices = this.config?.defPrices || null;

                if (this.defPrices !== null && Array.isArray(this.defPrices?.decoders)) {
                    this.decoders = [ ...this.defPrices.decoders ];

                    if (this.decoders.length > 0) {
                        let decoderPrice = 0.0;

                        for (let dec of this.decoders) {
                            if (dec.default) {
                                decoder = dec.value;
                                decoderPrice = dec.price;
                                break;
                            }
                        }

                        if (decoder == null) {
                            decoder = this.decoders[0].value;
                            decoderPrice = this.decoders[0].price;
                        }

                        if (!["fa", "tflm"].includes(this.org)) {
                            invoice["stb_mode"] = decoder;
                            invoice["stb_count"] = this.minRecorders;
                        }

                        if (this.minRecorders > 0) {
                            invoice['decoders'] = r2Dec(decoderPrice * this.minRecorders);
                        }
                    }
                }

                if (this.tvPlanId > 0) {
                    mdl = await this.context.getModelData({
                        model: 'tvplan',
                        id: this.tvPlanId,
                    });

                    if (mdl && mdl?.id > 0) {
                        this.tvPlan = mdl.getAll();
                        this.tvPlan.jdata = parseJsonOr(this.tvPlan.jdata, null);
                        invoice['tvplan'] = r2Dec(mdl.rec.planPrice);
                    }
                }

                this.setState({
                    overview: r2Dec(sumParts(invoice)),
                    invoice: invoice,
                    decoder: decoder,
                });
            }
        }

        this.setState({
            loading: false,
            validUrl: validUrl,
        });
    }

    onChange(name, value) {
        let {
            invoice,
            digital_recorder,
            digital_recorder_plus,
            unlimited_can_usa_long_distance,
            decoder,
            numOfDecoders,
        } = this.state;
        let decoderPrice = 0.0;

        switch (name) {
            case 'digital_recorder':
                digital_recorder = parseBoolOr(value, false);
                digital_recorder_plus = false;
                invoice['digital_recorder_plus'] = 0;
                invoice[name] = (digital_recorder) ? this.defPrices[name] : 0;
                this.formRef.current.setFieldsValue({
                    digital_recorder_plus: false,
                });
                break;

            case 'digital_recorder_plus':
                digital_recorder_plus = parseBoolOr(value, false);
                digital_recorder = false;
                invoice['digital_recorder'] = 0;
                invoice[name] = (digital_recorder_plus) ? this.defPrices[name] : 0;
                this.formRef.current.setFieldsValue({
                    digital_recorder: false,
                });
                break;

            case 'unlimited_can_usa_long_distance':
                unlimited_can_usa_long_distance = parseBoolOr(value, false);
                invoice[name] = (unlimited_can_usa_long_distance) ? this.defPrices[name] : 0;
                break;

            case "decoderManagementAmount":
            case "purchaseDecoderAmount":
            case "rentalDecoderAmount":
                this.formRef.current.setFieldValue(name, value);
                invoice[name] = value;
                break;

            case 'decoder':
                decoder = value;

                if (this.decoders.length > 0) {
                    for (let dec of this.decoders) {
                        if (dec.value === decoder) {
                            decoderPrice = dec.price;
                            break;
                        }
                    }
                }

                invoice["stb_mode"] = decoder;
                invoice["stb_count"] = numOfDecoders;
                invoice['decoders'] = r2Dec(decoderPrice * numOfDecoders);
                break;

            case 'numOfDecoders':
                numOfDecoders = parseInt(value) || 0;

                if (this.decoders.length > 0) {
                    for (let dec of this.decoders) {
                        if (dec.value === decoder) {
                            decoderPrice = dec.price;
                            break;
                        }
                    }
                }

                invoice["stb_mode"] = decoder;
                invoice["stb_count"] = numOfDecoders;
                invoice['decoders'] = r2Dec(decoderPrice * numOfDecoders);
                break;

            default:
                // Payment Method
                if (this.paymentMethods.length > 0 &&
                    this.paymentMethods.indexOf(name) > -1) {
                    value = parseBoolOr(value, false);

                    if (value) {
                        for (let i = 0; i < this.paymentMethods.length; i ++) {
                            if (name !== this.paymentMethods[i]) {
                                this.formRef.current.setFieldsValue({[this.paymentMethods[i]]: false});
                            }
                        }
                    }
                }
                break;
        }

        this.setState({
            overview: r2Dec(sumParts(invoice)),
            invoice: invoice,
            digital_recorder: digital_recorder,
            digital_recorder_plus: digital_recorder_plus,
            unlimited_can_usa_long_distance: unlimited_can_usa_long_distance,
            decoder: decoder,
            numOfDecoders: numOfDecoders,
        });
    }

    async onFinish(values) {
        if (this.state.processing) {
            return;
        }

        this.setState({processing: true});

        const { t, i18n, history } = this.props;
        let credit_card = parseBoolOr(values.credit_card, false);
        let bank_transfer = parseBoolOr(values.bank_transfer, false);
        let other = parseBoolOr(values.other, false);

        if (this.paymentMethods.length > 0 && (!credit_card && !bank_transfer && !other)) {
            Modal.error({
                title: t('SignUpRequest.required_payment_title'),
                content: t('SignUpRequest.required_payment_content'),
            });
        }
        else {
            values.address = createFormattedAddress({
                civic: values.address_civic,
                suite: values.address_suite,
                street: values.address_street,
                city: values.address_city,
                state: values.address_state,
                zip: values.address_zip,
                country: values.address_country,
            });
            values.planId = this.plan.id;
            values.planApiCode = this.planApiCode;
            values.tvPlanId = this.tvPlanId;
            values.overview = this.state.overview;
            values.overviewBasedOn = {
                defaultPricies: this.defPrices,
                selections: this.state.invoice,
            };
            values.lang = i18n.language || "en";

            let response = await this.context.doModelAction({
                model: "signuprequest",
                action: "signup",
                data: {
                    des: "Inserted from website form",
                    jdata: values,
                    planId: this.plan.id,
                    tvPlanId: this.tvPlanId,
                }
            });

            if (response && response?.data) {
                if (response.data.state === "already_exists") {
                    history.push(`/ongoing/${response.data.id}`);
                }
                else {
                    history.push(`/view/${response.data.id}`);
                }
            }
        }

        this.setState({processing: false});
    }

    render() {
        const { t, i18n } = this.props;
        //let planTvDesField = 'des';
        let planLabelField = 'label';
        let signupFooterText = 'signupFooterTextEn';
        let currency = "USD";

        if (i18n.language === 'fr') {
            //planTvDesField = 'desFr';
            planLabelField = 'labelFr';
            signupFooterText = 'signupFooterTextFr';
            currency = "CAD";
        }

        return (
            <PageView
                leadText={t('SignUpRequest.leadText')}
                title={t('SignUpRequest.title')}
                loading={this.state.loading}
                subTitle={this.state.validUrl && t('SignUpRequest.subTitle')}
            >
                {this.state.loading && (<Loading />)}
                {(!this.state.loading && this.state.validUrl) && (
                <Form
                    ref={this.formRef}
                    layout="vertical"
                    onFinish={this.onFinish}
                    scrollToFirstError={true}
                    initialValues={{
                        decoder: this.state.decoder,
                        numOfDecoders: this.minRecorders,
                        address_state: this.defAddressState,
                        address_country: this.defAddressCountry
                    }}
                >
                    <PageViewSection
                        className="sur-list"
                        section={t('SignUpRequest.section_number', { number: 1 })}
                        title={t('SignUpRequest.section_1_title')}
                    >
                        <Row gutter={GUTTER}>
                            <Col {...COL_SIZE}>
                                <div className="col-cnt col-cnt-left with-end-div">
                                    <span>{this.plan[planLabelField]}</span>
                                    <div className="col-cnt-left-icons">
                                        {this.plan.isNet > 0 && (<PlanIcon type="net" />)}
                                        {this.plan.isVoice > 0 && (<PlanIcon type="voice" />)}
                                        {this.plan.isTv > 0 && (<PlanIcon type="tv" />)}
                                    </div>
                                </div>
                            </Col>
                            <Col {...COL_SIZE_PRICE}>
                                <div className="col-cnt col-cnt-right">
                                    {moneyFormat(this.plan.monthlyPrice, currency)}
                                </div>
                            </Col>
                        </Row>
                        {isObjectNotEmpty(this.tvPlan) && (
                        <Row gutter={GUTTER}>
                            <Col {...COL_SIZE}>
                                <div className="col-cnt col-cnt-left">
                                    <span>{t('SignUpRequest.tv_plan_title')}</span>
                                    <div className='tv-plan-review-list'>
                                    <ul>
                                        {this.tvPlan.jdata.selData.checklist.map((item, index) => (
                                        <li key={`tvplan-review-fav-${index}`}>
                                            <Row gutter={GUTTER}>
                                                <Col {...COL_SIZE}>
                                                    <FontAwesomeIcon className="fai" icon={faCheckCircle} />
                                                    <span>{item.des}</span>
                                                </Col>
                                                <Col {...COL_SIZE_PRICE} style={{textAlign: 'right'}}>
                                                    <span>{item.price > 0 ? (<Price>{item.price}</Price>): null}</span>
                                                </Col>
                                            </Row>
                                        </li>
                                        ))}
                                    </ul>
                                </div>
                                </div>
                            </Col>
                            <Col {...COL_SIZE_PRICE}>
                                <div className="col-cnt col-cnt-right">
                                    {moneyFormat(this.tvPlan.planPrice, currency)}
                                </div>
                            </Col>
                        </Row>
                        )}
                    </PageViewSection>
                    {!this.hideSectionTwo && (
                    <PageViewSection
                        className="sur-list"
                        section={t('SignUpRequest.section_number', { number: 2 })}
                        title={t('SignUpRequest.section_2_title')}
                    >
                        {this.hasSectionTwoCustom ? (
                        <p style={{fontSize: 16, marginBottom: 0}}>
                            {t('SignUpRequest.install_fees_paragragh')}
                        </p>
                        ) : (
                        <React.Fragment>
                        <Row gutter={GUTTER}>
                            <Col {...COL_SIZE}>
                                <div className="col-cnt col-cnt-left">
                                    <span>{t(`SignUpRequest.${(this.org === "ctal") ? "tv_plan_ctal_setup" : "tv_plan_setup"}`)}</span>
                                </div>
                            </Col>
                            <Col {...COL_SIZE_PRICE}>
                                {this.plan.freeSetupFee > 0 ? (
                                <div className="col-cnt col-cnt-right">
                                    {moneyFormat(this.plan.planSetupFee, currency)}
                                </div>
                                ) : (
                                <div className="col-cnt col-cnt-right">
                                    {moneyFormat(this.plan.planSetupFee, currency)}
                                </div>
                                )}
                            </Col>
                        </Row>
                        {this.plan.freeSetupFee > 0 && (
                        <Row gutter={GUTTER}>
                            <Col {...COL_SIZE}>
                                <div className="col-cnt col-cnt-left">
                                    <span>{t(`SignUpRequest.${(this.org === "ctal") ? "tv_plan_ctal_setup_free" : "tv_plan_setup_free"}`)}</span>
                                </div>
                            </Col>
                            <Col {...COL_SIZE_PRICE}>
                                <div className="col-cnt col-cnt-right">
                                    {moneyFormat(this.plan.planSetupFee*-1, currency)}
                                </div>
                            </Col>
                        </Row>
                        )}
                        </React.Fragment>
                        )}
                    </PageViewSection>
                    )}
                    <PageViewSection
                        className="sur-form-fiels"
                        section={t('SignUpRequest.section_number', { number: this.hideSectionTwo ? 2 : 3 })}
                        title={t('SignUpRequest.section_3_title')}
                    >
                        <Row gutter={GUTTER}>
                            {this.themeConfig?.hasDataProtetionAccept && (
                            <Col {...COL_SIZE}>
                                <InputCheckbox
                                    className="mr-0"
                                    name="dataProtectionAccepted"
                                    rules={[{
                                        required: true,
                                        transform: value => (value || undefined),
                                        type: 'boolean',
                                        message: t('SignUpRequest.data_protection_policy_required'),
                                    }]}
                                >
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: t('SignUpRequest.ctal_decoder_help_text', {
                                                interpolation: {
                                                    escapeValue: false,
                                                },
                                            }),
                                        }}
                                    />
                                </InputCheckbox>
                            </Col>
                            )}
                            <Col {...COL_SIZE}>
                                <InputText
                                    name="name"
                                    label={t('SignUpRequest.name')}
                                    placeholder={t('SignUpRequest.name_ph')}
                                    requiredMessge={t('SignUpRequest.name_rm')}
                                />
                            </Col>
                            <Col {...COL_SIZE}>
                                <Row gutter={GUTTER}>
                                    <Col xs={24} sm={12}>
                                        <InputText
                                            name="address_suite"
                                            label={t('SignUpRequest.suite')}
                                            placeholder={t('SignUpRequest.suite_ph')}
                                            required={false}
                                            onChange={this.onChange}
                                        />
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <InputText
                                            name="address_civic"
                                            label={t('SignUpRequest.civic')}
                                            placeholder={t('SignUpRequest.civic_ph')}
                                            requiredMessge={t('SignUpRequest.civic_rm')}
                                            onChange={this.onChange}
                                        />
                                    </Col>
                                    <Col xs={24}>
                                        <InputText
                                            name="address_street"
                                            label={t('SignUpRequest.street')}
                                            placeholder={t('SignUpRequest.street_ph')}
                                            requiredMessge={t('SignUpRequest.street_rm')}
                                            onChange={this.onChange}
                                        />
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <InputText
                                            name="address_city"
                                            label={t('SignUpRequest.city')}
                                            placeholder={t('SignUpRequest.city_ph')}
                                            requiredMessge={t('SignUpRequest.city_rm')}
                                            onChange={this.onChange}
                                        />
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <InputText
                                            name="address_state"
                                            label={t('SignUpRequest.state')}
                                            placeholder={t('SignUpRequest.state_ph')}
                                            requiredMessge={t('SignUpRequest.state_rm')}
                                            onChange={this.onChange}
                                        />
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <InputText
                                            name="address_zip"
                                            label={t('SignUpRequest.zip')}
                                            placeholder={t('SignUpRequest.zip_ph')}
                                            requiredMessge={t('SignUpRequest.zip_rm')}
                                            onChange={this.onChange}
                                        />
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <InputText
                                            name="address_country"
                                            label={t('SignUpRequest.country')}
                                            placeholder={t('SignUpRequest.country_ph')}
                                            requiredMessge={t('SignUpRequest.country_rm')}
                                            onChange={this.onChange}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col {...COL_SIZE}>
                                <InputText
                                    name="phone"
                                    label={t('SignUpRequest.phone')}
                                    placeholder={t('SignUpRequest.phone_ph')}
                                    requiredMessge={t('SignUpRequest.phone_rm')}
                                />
                            </Col>
                            <Col {...COL_SIZE}>
                                <InputEmail
                                    name="email"
                                    label={t('SignUpRequest.email')}
                                    placeholder={t('SignUpRequest.email_ph')}
                                    requiredMessge={t('SignUpRequest.email_rm')}
                                    style={this.showReferral? null : {marginBottom: 0}}
                                />
                            </Col>
                            {this.showReferral && (
                            <Col {...COL_SIZE}>
                                <InputText
                                    name="referral"
                                    label={t(`SignUpRequest.${this.org}_referral`)}
                                    placeholder={t(`SignUpRequest.${this.org}_referral_ph`)}
                                    required={false}
                                    style={{marginBottom: 0}}
                                />
                            </Col>
                            )}
                        </Row>
                    </PageViewSection>
                    {(this.plan.isTv > 0 || this.plan.isVoice > 0) && (
                    <PageViewSection className="sur-list" title={t('SignUpRequest.section_4_title')}>
                        {(this.plan.isVoice > 0 && this.defPrices?.unlimited_can_usa_long_distance > 0) && (
                        <Row gutter={GUTTER}>
                            <Col {...COL_SIZE}>
                                <div className="col-cnt col-cnt-left">
                                    <InputCheckbox
                                        className="fix-min-height"
                                        name="unlimited_can_usa_long_distance"
                                        onChange={(e) => this.onChange("unlimited_can_usa_long_distance", e.target.checked)}
                                        style={{marginBottom: 0}}
                                    >
                                        {t('SignUpRequest.unlimited_can_usa_long_distance')}
                                    </InputCheckbox>
                                </div>
                            </Col>
                            <Col {...COL_SIZE_PRICE}>
                                <div className="col-cnt col-cnt-right">
                                    {this.state.unlimited_can_usa_long_distance
                                        ? moneyFormat(this.defPrices.unlimited_can_usa_long_distance, currency)
                                        : null}
                                </div>
                            </Col>
                        </Row>
                        )}
                        {this.plan.isTv > 0 && (
                        <React.Fragment>
                        <Row gutter={GUTTER}>
                            <Col {...COL_SIZE}>
                                <div className="col-cnt col-cnt-left">
                                    <InputCheckbox
                                        name="digital_recorder"
                                        className="fix-min-height"
                                        onChange={(e) => this.onChange('digital_recorder', e?.target?.checked)}
                                        checked={(this.state.digital_recorder > 0)}
                                    >
                                        {t('SignUpRequest.digital_recorder', {hours: this.defPrices.digital_recorder_hours || 50})}
                                    </InputCheckbox>
                                </div>
                            </Col>
                            <Col {...COL_SIZE_PRICE}>
                                <div className="col-cnt col-cnt-right">
                                    {this.state.digital_recorder
                                        ? moneyFormat(this.defPrices.digital_recorder, currency)
                                        : null}
                                </div>
                            </Col>
                        </Row>
                        {this.defPrices?.digital_recorder_plus > 0 && (
                        <Row gutter={GUTTER}>
                            <Col {...COL_SIZE}>
                                <div className="col-cnt col-cnt-left">
                                    <InputCheckbox
                                        name="digital_recorder_plus"
                                        className="fix-min-height"
                                        onChange={(e) => this.onChange('digital_recorder_plus', e?.target?.checked)}
                                        checked={(this.state.digital_recorder_plus > 0)}
                                    >
                                        {t('SignUpRequest.digital_recorder_plus', {hours: this.defPrices.digital_recorder_plus_hours || 120})}
                                    </InputCheckbox>
                                </div>
                            </Col>
                            <Col {...COL_SIZE_PRICE}>
                                <div className="col-cnt col-cnt-right">
                                    {this.state.digital_recorder_plus
                                        ? moneyFormat(this.defPrices.digital_recorder_plus, currency)
                                        : null}
                                </div>
                            </Col>
                        </Row>
                        )}
                        {this.plan.includeDecoder > 0 && (
                        <Row gutter={GUTTER}>
                            <Col {...COL_SIZE}>
                                <div className="col-cnt col-cnt-left">
                                    <InputCheckbox
                                        name="include_decoder"
                                        className="fix-min-height"
                                        defaultChecked={true}
                                        disabled={true}
                                        style={{marginBottom: 0}}
                                    >
                                        {t('SignUpRequest.include_decoder')}
                                    </InputCheckbox>
                                </div>
                            </Col>
                            <Col {...COL_SIZE_PRICE}>
                                <div className="col-cnt col-cnt-right"> {null}</div>
                            </Col>
                        </Row>
                        )}
                        {["fa", "tflm"].includes(this.org) ? (
                        <DecoderPlans
                            onChange={this.onChange}
                            decoder={this.state.decoder}
                            formRef={this.formRef}
                            minRecorders={this.minRecorders}
                            currency={currency}
                        />
                        ) : (
                        <Decoders
                            decoders={this.decoders}
                            onChange={this.onChange}
                            decoder={this.state.decoder}
                            formRef={this.formRef}
                            minRecorders={this.minRecorders}
                            amount={moneyFormat(this.state.invoice['decoders'], currency)}
                        />
                        )}
                        </React.Fragment>
                        )}
                    </PageViewSection>
                    )}
                    {this.paymentMethods.length > 0 && (
                    <PageViewSection className="sur-list" title={t('SignUpRequest.section_5_title')}>
                        {this.paymentMethods.map(method => (
                        <Row gutter={GUTTER} key={`payment-methods-${method}`}>
                            <Col {...COL_SIZE}>
                                <div className="col-cnt col-cnt-left">
                                    <InputCheckbox
                                        name={method}
                                        className="fix-min-height"
                                        onChange={(e) => this.onChange(method, e.target.checked)}
                                        style={{marginBottom: 0}}
                                    >
                                        {t(`SignUpRequest.${method}`)}
                                    </InputCheckbox>
                                </div>
                            </Col>
                        </Row>
                        ))}
                    </PageViewSection>
                    )}
                    <PageViewSection className="sur-list surl-overview">
                        <Row gutter={GUTTER} justify="end">
                            <Col {...COL_SIZE} md={10}>
                                <div className="col-cnt col-cnt-left nobr">
                                    <span dangerouslySetInnerHTML={{__html: t('SignUpRequest.overview')}} />
                                    <sup className="sup">&nbsp;(1)</sup>
                                </div>
                            </Col>
                            <Col {...COL_SIZE_PRICE}>
                                <div className="col-cnt col-cnt-right">
                                    {moneyFormat(this.state.overview, currency)}
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={GUTTER} justify="end">
                            <Col {...COL_SIZE} md={12}>
                                <sup className="sup">(1)</sup>
                                <span style={{fontSize: 12}}>&nbsp;{t('SignUpRequest.footer_note')}</span>
                            </Col>
                        </Row>
                    </PageViewSection>
                    <PageViewSection style={{textAlign: 'right'}} className="sur-buttons">
                        <Button
                            className="sur-btn"
                            htmlType="submit"
                            loading={this.state.processing}
                            type="text">
                             {t('Confirm')}
                             <FontAwesomeIcon
                                icon={faArrowCircleRight}
                                size="lg"
                                style={{marginLeft: 12}}
                            />
                        </Button>
                    </PageViewSection>
                    {this.plan[signupFooterText] != null && (
                    <PageViewSection section={t('Notes')}>
                        <div
                            style={{textAlign: 'justify'}}
                            dangerouslySetInnerHTML={{__html: this.plan[signupFooterText]}}
                        />
                    </PageViewSection>
                    )}
                </Form>
                )}
                {(!this.state.loading && !this.state.validUrl) && (
                <Alert
                    message="Error"
                    description={t('SignUpRequest.alert_error')}
                    type="error"
                    showIcon
                />
                )}
            </PageView>
        );
    }
}

export default withRouter(withTranslation('appxweb')(SignUpRequest));
